import { useMatches } from "@tanstack/react-router";
import type { ReactNode } from "react";

export const Layout = (props: { children: ReactNode }) => {
  const matches = useMatches(); // Get all active route matches

  const isMenuDining = matches.some(
    (match) => match.routeId === "/(menu)/menu/dining"
  );
  return (
    <div
      className={`m-auto w-full md:w-[834px] px-6 h-screen items-center ${isMenuDining ? "overflow-clip" : ""}`}
    >
      {props.children}
    </div>
  );
};
